import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import useDataApi from '../../hooks/useDataApi';
import WidgetBox from '../layout/WidgetBox/WidgetBox';
import { MarketIndicatorsIcon } from '../../styles/icons/icons';
import List from '../list/List';
import { dashboardHeader, pageHeader } from './MarketIndicatorsColumns';

const Dashboard = ({ data }) => (
	<WidgetBox header="Market Indicators">
		<div className="card-header">
			<h3 className="card-title">
				<MarketIndicatorsIcon /> Market Indicators
			</h3>
		</div>
		<List
			newData={data}
			columns={dashboardHeader}
			isPagination={false}
			pageSize={3}
			tableClass="sidebar-widget"
		/>
		<div className="text-right">
			<NavLink to="/markets" className="link-text">
				&gt; View More
			</NavLink>
		</div>
	</WidgetBox>
);

const Page = ({ data }) => {
	return (
		<>
			<List newData={data} columns={pageHeader()} />
		</>
	);
};

const ViewSelector = ({ data, type }) =>
	type === 'short' ? <Dashboard data={data} /> : <Page data={data} />;

const View = ({ data, isLoading, isError, type = 'short' }) => (
	<>
		{isError && <div>Something went wrong</div>}
		{isLoading ? <div>Loading...</div> : <ViewSelector data={data} type={type} />}
	</>
);

const MarketIndicators = ({ type, refreshPage }) => {
	const url = `/markets?hash=${refreshPage}`;
	const [dataProps, setUrl] = useDataApi(url, [], { method: 'POST' });

	useEffect(() => {
		setUrl(url);
	}, [refreshPage]);

	return <View {...dataProps} type={type} />;
};

export default MarketIndicators;
